import { Data, Params } from '@angular/router';

export interface RouterState {
  url: string;
  data: Data;
  params: Params;
  queryParams: Params;
}

export interface RouterNavStateModel {
  state: RouterState;
}

export enum RouterPath {
  _ = '.',
  AgencySettings = '/settings/agency',
  CustomerSettings = '/settings/customer',
  Monitor = '/monitor',
  Notifications = '/notifications',
  CustomerRetailAccounts = 'settings/customer/retail-accounts',
  CustomerAccountSettings = '/settings/customer/accounts',
  AgencyAccountGroupSettings = '/settings/agency/account-groups',
  CustomerIntegrationSettings = '/settings/customer/integrations',
  CustomerSubscriptionSettings = '/settings/customer/subscription',
  Goals = '/goals',
  OptimizationSettings = '/optimization-settings',
  Products = '/products',
  KeyFigures = '/keyfigures',
  Logs = '/log',
  GoalsLog = '/log/goals',
  CreateCampaignLog = '/log/create-campaigns',
  RulesLog = '/log/rules',
  BiddingLog = '/log/bidding',
  BiddingAdjustment = '/log/bid-adjustment',
  ProductAdsSettingsLog = '/log/product-ads-settings',
  BudgetSuggestionsLog = '/log/budget-suggestions',
  CampaignCreationLog = '/log/campaign-creation',
  AdGroupCreationLog = '/log/ad-group-creation',
  SuggestionsLog = '/log/suggestions',
  ProductAdsSyncLog = '/log/ads-sync',
  OptimizationSettingsLog = '/log/optimization-settings',
  SettingChangesLog = '/log/setting-changes',
  CriterionAdditionRulesSimpleMode = '/criterion-addition/rules/simple',
  CriterionAdditionRulesAdvancedMode = '/criterion-addition/rules/advanced',
  CampaignQueue = '/campaign/queue',
}

export interface RouterRefreshOptions {
  newTab?: boolean;
}
